import axios from 'axios';

/**
 * Public API client (no Authorization header).
 * Guest entry endpoints are public and should not be coupled to any JWT that
 * might exist in localStorage from other apps/environments.
 */
const BASE_URL =
  process.env.REACT_APP_API_URL ||
  // 'https://event-sharing-server-6dd4a92d6d2a.herokuapp.com/api';
  'http://localhost:3000/api';

const apiPublic = axios.create({
  baseURL: BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
  timeout: 60000,
});

export { apiPublic };
export default apiPublic;

